import { useDispatch } from 'react-redux'
import { StudioTextInput } from 'apps/studio/components/shared/inputs/StudioTextInput'
import { getAdditionalProps } from 'apps/studio/components/settings/inputs'

export const SettingsInput = ({
  property,
  id,
  label,
  tooltipContent = '',
  data,
  update,
  additionalClasses = '',
  additionalProps = {},
  iconComponent = null,
  iconPosition = 'leading',
  placeholder = '',
  labelAbove,
  inputSmall,
  validation = false,
}) => {
  const dispatch = useDispatch()
  const { [property]: value } = data

  const handleChange = value => {
    dispatch(
      update({
        [property]: value,
      })
    )
  }

  // a bit arbitrary
  if ((label.length >= 16 && !inputSmall) || labelAbove) {
    additionalClasses += ' label--above'
  }
  if (inputSmall) {
    additionalClasses += ' input--small'
  }

  return (
    <StudioTextInput
      id={id}
      placeholder={placeholder}
      value={value}
      label={label}
      onChange={handleChange}
      additionalClasses={additionalClasses}
      additionalProps={getAdditionalProps(additionalProps, data)}
      settingType="textInput"
      validation={validation}
      tooltipContent={tooltipContent}
      iconPosition={iconPosition}
      IconComponent={iconComponent}
    />
  )
}
